import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_106: FaireProductEntity = {
  token: "catalog_prod_prod-106",
  type: "product",
  name: "Wall Decor - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 31.67,
  msrpDollars: 79.18,
  sku: "CA0106",
  caseSize: 4,
  material: "Ceramic",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 323,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_throw-pillows"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
